import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    interest: 'Health Insurance',
    mobile: '',
    callTime: 'Morning(9:30am - 12pm)',
  });

  const [submitted, setSubmitted] = useState(false);
  const [requestId, setRequestId] = useState('');
  const [errors, setErrors] = useState({});

  const API_BASE_URL = process.env.REACT_APP_LOGIN_API_BASE_URL;
  console.log('API_BASE_URL:', API_BASE_URL);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const validateMobile = (mobile) => /^[7-9][0-9]{9}$/.test(mobile);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.interest) {
      newErrors.interest = 'Please select your interest.';
    }

    if (!formData.mobile || !validateMobile(formData.mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.';
    }

    if (!formData.callTime) {
      newErrors.callTime = 'Please select preferred call time.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // const QueryForJson = {
    //   UserMobileNo: formData.mobile,
    //   QueryFor: formData.interest,
    // }; 
    const combinedRemarks = formData.interest + ' Call On :' + formData.callTime;


    const QueryForJson = {
      Name: null,
      Email_Id: null,
      Contact_No: formData.mobile,
      City: null,
      Remark: combinedRemarks,
      Visitor_Id: null,
    };

    console.log('API Request:', QueryForJson);

    try {

      const response = await fetch(
        `${API_BASE_URL}/SaveContactUs`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(QueryForJson),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log('API ResponseJamal:', result);

      // console.log('StatusJamal:', result.Status);
      // console.log('RequestJamal:', result.RequestId);

      if (result?.Status === 'Success') {
        setSubmitted(true);
        setRequestId(result.RequestId);

      }

      setFormData({
        interest: 'Health Insurance',
        mobile: '',
        callTime: 'Morning(9:30am - 12pm)',
      });
      setErrors({});

    } catch (error) {

      console.error('Error submitting form:', error);
      //alert('Failed to submit. Please try again later.');
    }
  };

  if (submitted) {
    return (
      <p className="enq-contact">
        <label id="ContentPlaceHolder1_RetReqno">
          Reference Number : <strong>{requestId}</strong>
        </label>
        <br /><br />
        Someone from the team will get back to you soon!
        <br /><br />
        HAVE A GREAT DAY!
        <br /><br />
        If it's super urgent,
        <br /><br />
        Call us on our Toll Free number below
        <br /><br />
        1800-212-123123
      </p>
    );
  }

  return (

    <div className="custom-form">
      <form id="form2" onSubmit={handleSubmit}>
        <h6 className="text-center form-heading">Request a Callback</h6>
        <div className="row">

          {/* Interest Dropdown */}
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="interest">YOU ARE INTERESTED IN</label>
              <select
                className="form-control"
                id="interest"
                name="interest"
                value={formData.interest}
                onChange={handleChange}
              >
                <option value="Health Insurance">Health Insurance</option>
                <option value="Travel Insurance">Travel Insurance</option>
                <option value="Motor Insurance">Motor Insurance</option>
                <option value="Term Insurance">Term Insurance</option>
              </select>
              {errors.interest && <small className="text-danger">{errors.interest}</small>}
            </div>
          </div>

          {/* Mobile Input */}
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="mobile">MOBILE NUMBER</label>
              <input
                type="text"
                maxLength="10"
                className="form-control"
                id="mobile"
                name="mobile"
                placeholder="Enter your Mobile Number here"
                value={formData.mobile}
                onChange={handleChange}
                onInput={(e) => {
                  if (e.target.value.length === 1 && !/[7-9]/.test(e.target.value)) {
                    e.target.value = '';
                  }
                }}
              />
              {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
            </div>
          </div>

          {/* Call Time Dropdown */}
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="callTime">REQUEST CALL BETWEEN</label>
              <select
                className="form-control"
                id="callTime"
                name="callTime"
                value={formData.callTime}
                onChange={handleChange}
              >
                <option value="Morning(9:30am - 12pm)">Morning (9:30am - 12pm)</option>
                <option value="Afternoon(12pm - 3pm)">Afternoon (12pm - 3pm)</option>
                <option value="Late Afternoon(3pm - 5pm)">Late Afternoon (3pm - 5pm)</option>
                <option value="Evening(5pm - 8pm)">Evening (5pm - 8pm)</option>
              </select>
              {errors.callTime && <small className="text-danger">{errors.callTime}</small>}
            </div>
          </div>

          {/* Submit Button */}
          <div className="col-md-12 text-center">
            <button type="submit" className="btn button">Submit</button>
          </div>

        </div>
      </form>
    </div>
  );
};

export default ContactForm;
